import { createContext } from "react";

const ParivarSabhaContext = createContext({});

export default ParivarSabhaContext;
